module.exports = __webpack_public_path__ + "static/media/bg_blue.72d00287.svg";